import React from 'react';
import { core_apimessages_Address } from '../../../schemas/rql';
import AddressSummary from '../address_summary';

interface IProps {
  loading: boolean;
  address: core_apimessages_Address;
}

export default class ShippingAddress extends React.Component<IProps, null> {
  renderPlaceholder() {
    return (
      <p className="formatted-address formatted-address--placeholder">
        <span className="formatted-address__highlight" />
      </p>
    );
  }

  render() {
    if (this.props.loading) { return this.renderPlaceholder(); }

    const { address } = this.props;

    return <AddressSummary address={address} />;
  }
}
